import React from 'react';
import { useTranslation } from 'react-i18next';
import { unstable_usePrompt } from 'react-router-dom';

import { useModalPrompt } from 'hooks';

// Alias for usePrompt hook to keep the same API as react-router-dom used to have in v5
// until the <Prompt /> component is officially re-implemented in v(6?)
const Prompt: React.FC<{ when: boolean; message?: string }> = ({ when, message }) => {
    const { t } = useTranslation();

    const confirmMessage = message ?? t('Common.PromptUnsavedChanges') ?? 'Are you sure you want to leave this page?';

    unstable_usePrompt({ when, message: confirmMessage });
    useModalPrompt(confirmMessage, when);

    return null;
};

export default Prompt;
